// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79","outlined_button":"Button_outlined_button__1Tw8n"};